import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertWarning16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.07971 1.86247C8.59736 1.03559 7.40261 1.03559 6.92026 1.86247L0.79081 12.3702C0.304709 13.2035 0.905797 14.25 1.87053 14.25H5.50002V12.75H2.30579L7.99999 2.98847L13.6942 12.75H10.5V14.25H14.1295C15.0942 14.25 15.6953 13.2035 15.2092 12.3702L9.07971 1.86247Z'
      fill='currentColor'
    />
    <path d='M8.75 6.5V11.5H7.25V6.5H8.75Z' fill='currentColor' />
    <path
      d='M8 14.5C8.55228 14.5 9 14.0523 9 13.5C9 12.9477 8.55228 12.5 8 12.5C7.44772 12.5 7 12.9477 7 13.5C7 14.0523 7.44772 14.5 8 14.5Z'
      fill='currentColor'
    />
  </Svg>
);

AlertWarning16.displayName = 'AlertWarning16';
export default AlertWarning16;
